import {HOMEPAGE_TEMPLATE_KEY} from "../../utils/constants";
import {isTemplateEnabled} from "./isTemplateEnabled";

export function isShowingBottomTabs(appStyles){
    const newsfeedTemplateIsSelected = isTemplateEnabled(appStyles, HOMEPAGE_TEMPLATE_KEY.newsfeed);
    const pointsTemplateIsSelected = isTemplateEnabled(appStyles, HOMEPAGE_TEMPLATE_KEY.loyalty);
    const minimalistTemplateSelected = isTemplateEnabled(appStyles, HOMEPAGE_TEMPLATE_KEY.minimalist);
    return newsfeedTemplateIsSelected || pointsTemplateIsSelected || minimalistTemplateSelected;
  }